var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/CheckboxOn.svg';
import '@patsnap-ui/icon/assets/solid/CheckboxOff.svg';
import '@patsnap-ui/icon/assets/solid/CheckboxClose.svg';
let FieldPtCheckbox = class FieldPtCheckbox extends Vue {
    get checkboxIcon() {
        if (this.indeterminate) {
            return 'SolidCheckboxClose';
        }
        if (this.checked) {
            return 'SolidCheckboxOn';
        }
        return 'SolidCheckboxOff';
    }
    onClick() {
        if (this.disabled)
            return false;
        this.$emit('click');
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], FieldPtCheckbox.prototype, "checked", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], FieldPtCheckbox.prototype, "indeterminate", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], FieldPtCheckbox.prototype, "disabled", void 0);
FieldPtCheckbox = __decorate([
    Component({
        name: 'FieldPtCheckbox',
        components: {
            PtIcon,
        }
    })
], FieldPtCheckbox);
export default FieldPtCheckbox;
